<ng-container *transloco="let t">
  <div class="mb-6 rounded-lg border p-4 shadow">
    <div class="inline-block font-medium">{{ getSegmentName() }}</div>
    @if (tactic().tacticType === "BLACKLIST") {
      <IBadge
        color="gray"
        [label]="t('common.blacklist') + ' ' + getSegmentTypeLabel()"
        [tooltipValue]="getSegmentTypeDesc()"
        class="ml-2"
        size="xs"
      />
    }
    <IBadge color="gray" variant="soft" size="xs" class="ml-2">
      <ng-template #labelSlot>
        <span class="text-gray-500">
          {{ getSegmentTypeLabel().toString() + ":" }}
        </span>
        <span class="ml-1 text-xs text-gray-800">
          @if (this.segmentType() === SegmentType.KeywordSegment) {
            {{ nbKeywords() }}
          } @else {
            {{ nbProductTargeting() }}
          }
        </span>
      </ng-template>
    </IBadge>
    @if (segmentType() === SegmentType.KeywordSegment && !showKW) {
      <span class="ml-2">
        <IIcon
          name="alertTriangle"
          class="warning text-lg"
          [iTooltip]="t('tactic.keywords_targeting_are_not_supported_on_sd_strategies')"
        />
        <span class="pl-1">{{ t("tactic.keywords_targeting_are_not_supported_on_sd_strategies") }} </span>
      </span>
    }
    <div class="float-right flex items-center">
      @if (segmentType() === SegmentType.ProductSegment && !showProducts) {
        <span class="ml-2">
          <IIcon
            name="alertTriangle"
            class="warning text-lg"
            [iTooltip]="t('tactic.product_targeting_has_been_disabled_for_this_strategy')"
          />
          <span class="pl-1">{{ t("tactic.product_targeting_has_been_disabled_for_this_strategy") }}</span>
        </span>
      }
      @if (_strategy()?.autoAlgoExplorationEnabled || !lastTacticForTargeting()) {
        <button
          iButton
          variant="ghost"
          size="icon-sm"
          testId="btn-delete-tactic"
          [disabled]="isReadOnly"
          (click)="!isReadOnly && removeTacticFromStrategy(); $event.stopPropagation()"
        >
          <IIcon name="trash" />
        </button>
      } @else {
        <span
          class="text-muted-foreground inline-block cursor-default leading-none"
          [iTooltip]="t('tactic.disabled_auto_keyword')"
          (click)="$event.stopPropagation()"
        >
          <IIcon name="trash" class="text-lg" />
        </span>
      }
      <button iButton variant="ghost" size="icon-sm" (click)="editSegment()">
        <IIcon name="edit" />
      </button>
    </div>
    <br />
    @if (tactic().tacticType !== "BLACKLIST") {
      <div class="mt-4 mb-2 ml-2 flex" (click)="$event.stopPropagation()">
        @if (_strategy()?.algoMode !== AlgoMode.PRODUCT_LAUNCH) {
          <div class="w-max">
            <IIntensityStepper
              label="tactic.intensity"
              [options]="intensityOptions"
              [level]="intensity()"
              [disabled]="isReadOnly"
              (levelChange)="changeIntensity($event)"
            />
          </div>
        }
        @if (boostTopSearchEnabled() && nbKeywords() && nbKeywords()! > 0) {
          <div class="flex items-center justify-end">
            <div class="mr-4 text-blue-950">{{ t("tactic.only_top_of_search_placement") }}</div>

            <IToggle
              [disabled]="isReadOnly"
              [checked]="!!tactic().boostPlacementTop"
              (checkedChange)="switchBoostPlacementTop()"
            />
          </div>
        }
      </div>
    }
  </div>
</ng-container>
